import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { siteEffectiveShifts } from "@/lib/contractShifts";

/** Selector de turno para el Cronograma: en vez de tipear el horario a mano,
 * elegís una de las franjas ya contratadas en la ficha del objetivo (o de la
 * sede, si tiene horario propio). Deja igual la opción "Horario manual" como
 * excepción. Al elegir una franja, el padre recibe el objeto completo
 * (label/time_from/time_to) para autocompletar los inputs de hora. */
export function ShiftSelect({ clientId, siteId, clients, value, onSelectShift, testIdPrefix = "shift" }) {
  const [sites, setSites] = useState([]);

  useEffect(() => {
    if (!clientId) { setSites([]); return; }
    (async () => {
      try { const { data } = await api.get(`/clients/${clientId}/sites`); setSites(data || []); }
      catch { setSites([]); }
    })();
  }, [clientId]);

  if (!clientId) return null;

  const client = (clients || []).find((c) => c.id === clientId);
  const clientShifts = client?.contract_shifts || [];
  const site = siteId ? sites.find((s) => s.id === siteId) : null;
  const shifts = site ? siteEffectiveShifts(site, clientShifts) : clientShifts;

  return (
    <div className="field">
      <label>Turno</label>
      <select
        value={value || "manual"}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "manual") { onSelectShift(null); return; }
          const s = shifts.find((sh) => sh.id === v);
          if (s) onSelectShift(s);
        }}
        data-testid={`${testIdPrefix}-shift-select`}
      >
        {shifts.map((s) => (
          <option key={s.id} value={s.id}>{s.label || "Turno"} · {s.time_from}–{s.time_to}</option>
        ))}
        <option value="manual">Horario manual (excepción)</option>
      </select>
      {shifts.length === 0 && (
        <p style={{ fontSize: 11, color: "var(--invict-text-muted)", margin: "4px 0 0" }} data-testid={`${testIdPrefix}-shift-empty`}>
          Este objetivo no tiene franjas horarias cargadas en su ficha (Clientes → Información). Cargalas ahí para poder elegirlas acá.
        </p>
      )}
    </div>
  );
}
